import {
  Box,
  Center,
  Flex,
  Link,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  ModalHeader,
  Modal,
  ModalBody,
  Grid,
  useToast,
} from "@chakra-ui/react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useAuth } from "../context/authContext";
import RegisterForm from "../pages/RegisterForm";
import LoginForm from "./LoginForm";

export default function AuthModal({ finalRef, isOpen, onClose }) {
  const [activeAuth, setActiveAuth] = useState("login");
  const auth = useAuth();
  const toast = useToast();

  const login = async (data) => {
    await auth
      .login(data)
      .then((res) => {
        onClose();

        toast({
          title: "Success",
          description: `Authenticated as ${res.data.data.user.email}`,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const register = async (data) => {
    await auth
      .register(data)
      .then((res) => {
        onClose();

        toast({
          title: "Success",
          description: `Authenticated as ${res.data.data.user.email}`,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return (
    <>
      <Modal finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {activeAuth === "login" ? "Login" : "Register"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {activeAuth === "login" && (
              <>
                <LoginForm login={login} />
                <Box sx={{ borderRadius: "inherit" }}>
                  <Box>
                    <Link>
                      <Flex mt={10}>
                        <Box color="#223D5D">
                          <FontAwesomeIcon icon={faArrowLeft} />
                        </Box>
                        <Text color="#00A2E8" pl={5} m={0}>
                          Forgot Password
                        </Text>
                      </Flex>
                    </Link>
                  </Box>

                  <Box
                    bg="#F6F7F8"
                    py={4}
                    mt={8}
                    mb={4}
                    sx={{ textAlign: "center", borderRadius: "inherit" }}
                  >
                    <Center>
                      <Text mr="1">Don't Have an account?</Text>
                      <Text
                        color="#00A2E8"
                        sx={{ cursor: "pointer" }}
                        onClick={() => setActiveAuth("register")}
                      >
                        Register
                      </Text>
                    </Center>
                  </Box>
                </Box>
              </>
            )}

            {activeAuth === "register" && (
              <Grid
                bg="white"
                sx={{
                  maxWidth: "445px",
                  minHeight: "447px",
                  borderRadius: "10px",
                  fontWeight: 510,
                }}
                gridTemplateAreas="'header' 'body' 'footer'"
                gridTemplateRows="auto 1fr auto"
              >
                <Box sx={{ gridArea: "body" }}>
                  <RegisterForm register={register} />
                </Box>
                <Box
                  bg="#F6F7F8"
                  py={5}
                  mt={8}
                  mb={4}
                  gridArea="footer"
                  sx={{
                    textAlign: "center",
                    borderRadius: "inherit",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Text mr="1">Have an account?</Text>
                  <Text
                    sx={{ cursor: "pointer" }}
                    color="#00A2E8"
                    onClick={() => setActiveAuth("login")}
                  >
                    Login
                  </Text>
                </Box>
              </Grid>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
